type ClientGlobalsType = typeof import("../client_cw_globals_base/index.json");

export default (window as any).__ENV__ as ClientGlobalsType;